// tslint:disable-next-line
import { takeEvery } from 'redux-saga/effects';
import { TOAST_PUSH } from '../constants';
import { handleToastSaga } from './handleToastSaga';

export function* rootHandleToastSaga() {
  yield takeEvery(TOAST_PUSH, handleToastSaga);
}
